import { RouteComponentProps } from '@reach/router'
import * as React from 'react'
import ReactMarkdown from 'react-markdown'
import styled from 'styled-components'
import MarkdownString from './release-notes.md'

/**
 * Show a Markdown-rendered release note from a static file
 *
 * TODO: post from directory, not just a single (growing) file.
 */
export default class ReleaseNotesPage extends React.PureComponent<RouteComponentProps> {
  constructor(props: ReleaseNotesPage['props']) {
    super(props)
  }

  render() {
    return (
      <>
        <ReleaseNotesPageWrap>
          <ReactMarkdown className="markdown-body lisa-markdown-dark">{MarkdownString}</ReactMarkdown>
        </ReleaseNotesPageWrap>
      </>
    )
  }
}

const ReleaseNotesPageWrap = styled.div`
  width: 80%;
  min-width: 320px;
  max-width: 800px;
  margin: 0 auto;
  padding: 32px;
`
